export enum BackendFeatureField{
    id='training_id',
    name= 'feature_name',
    type='training_type',
    timeStarted= 'date_created',
    lastTrain='last_trained',
    isAccuracyInProgress='is_accuracy_in_progress'
}

export enum BackendVersionsField{
    versionNumber='version_number',
    lastTrain='last_modify',
    isActive='is_active',
    trainingAmount='num_of_training_images',
    isCanOpenEvalImages='is_can_open_eval_images'
}

export enum BackendQueryField{
    trainingAmount='num_of_training_files',
    evalAmount='num_of_evaluation_files',
    error= 'error_message'
}

export enum BackendDeployField{
    projectName='data_project_name',
    projectId='data_project_id',
    feature='feature_name',
    versions='feature_versions_data',
    versionNumber='version_number',
    versionId ='version_id',
    versionCreation= 'creation_timestamp',
    accountId= 'account_id',
    accountName= 'account_name',
    accountType= 'account_external_type',
    isCanOpenEvalImages='is_can_open_eval_images'
}

export enum BackendHistoryField{
    versionId='feature_version_id',
    name= 'feature_name',
    dateCreated= 'train_start_time',
    versionNumber= 'version_number',
    trainingAmount='num_of_training_images',
    isCanOpenEvalImages='is_can_open_eval_images'
}


export enum BackendTagField{
    name= 'tag_name',
    id= 'tag_id',
    isReadyForFineTune= 'isReadyForFineTune'
}

export enum BackendManualRefinementImagesField{
    name= 'image_name',
    manualRefinementId= 'manual_refinement_id',
    url = 'image_url',
    isBest= 'is_best',
    detectedClass = 'detected_class',
    fileServerId = 'file_id',
    subClusterId = 'sub_cluster_id'
}
